/** @type {import('zudoku').ZudokuConfig} */

const config = {
  site: {
    logo: {
      src: { light: '/yem_logo.png', dark: '/yem_logo.png' },
      alt: 'Yemnet',
      width: '130px'
    }
  },
  port: 3003,
  vite: {
    server: {
      host: '0.0.0.0',
      allowedHosts: true
    },
    preview: {
      host: '0.0.0.0',
      allowedHosts: true
    }
  },
  navigation: [
    {
      type: 'category',
      label: 'Documentation',
      items: [
        {
          type: 'category',
          label: 'Getting Started',
          icon: 'sparkles',
          items: [
            '/introduction',
            {
              type: 'link',
              icon: 'folder-cog',
              badge: {
                label: 'New',
                color: 'purple'
              },
              label: 'API Reference',
              to: '/api'
            }
          ]
        },
        {
          type: 'category',
          label: 'Useful Links',
          collapsible: false,
          icon: 'link',
          items: [
            {
              type: 'link',
              icon: 'globe',
              label: 'Yemnet Health Page',
              to: 'https://zudoku.dev/docs/'
            },
            {
              type: 'link',
              icon: 'globe',
              label: 'Uvosyo',
              to: 'https://app.yemnet.yemaachi.com'
            },
            {
              type: 'link',
              icon: 'globe',
              label: 'ViAL',
              to: 'https://vial.yemaachi.com'
            },
            {
              type: 'link',
              icon: 'globe',
              label: 'YeLo',
              to: 'https://yelo.yemaachi.com'
            },
            {
              type: 'link',
              icon: 'globe',
              label: 'YeP',
              to: 'https://yep.yemaachi.com'
            }
          ]
        }
      ]
    },
    {
      type: 'link',
      to: '/api',
      label: 'API Reference'
    }
  ],
  // redirects: [{ from: '/', to: '/introduction' }],
  apis: {
    type: 'file',
    input: './apis/openapi.yaml',
    path: '/api'
  }
}

export default config
